import createIcon from '../../createIcon';

/**
 * @component @name Flip
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMjFIMTdWMTlIMTVWMjFaTTE5IDlIMjFWN0gxOVY5Wk0zIDVWMTlDMyAyMC4xIDMuOSAyMSA1IDIxSDlWMTlINVY1SDlWM0g1QzMuOSAzIDMgMy45IDMgNVpNMTkgM1Y1SDIxQzIxIDMuOSAyMC4xIDMgMTkgM1pNMTEgMjNIMTNWMUgxMVYyM1pNMTkgMTdIMjFWMTVIMTlWMTdaTTE1IDVIMTdWM0gxNVY1Wk0xOSAxM0gyMVYxMUgxOVYxM1pNMTkgMjFDMjAuMSAyMSAyMSAyMC4xIDIxIDE5SDE5VjIxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Flip = createIcon('Flip', [
  [
    'path',
    {
      d: 'M15 21H17V19H15V21ZM19 9H21V7H19V9ZM3 5V19C3 20.1 3.9 21 5 21H9V19H5V5H9V3H5C3.9 3 3 3.9 3 5ZM19 3V5H21C21 3.9 20.1 3 19 3ZM11 23H13V1H11V23ZM19 17H21V15H19V17ZM15 5H17V3H15V5ZM19 13H21V11H19V13ZM19 21C20.1 21 21 20.1 21 19H19V21Z',
      key: 'jmnqee',
    },
  ],
]);

export default Flip;
